module.exports = __webpack_public_path__ + "img/usage_category.726d781c.png";